import { Box, styled } from "@mui/material";

export const HeaderConatiner = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: 1000,
  width: "100%",
  background: "#0d1117",
  borderBottom: "1px solid rgba(255,255,255,0.07)",
}));

export const AppBar = styled("div")(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  width: "100%",
  maxWidth: "1440px",
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 7.5),
  height: "80px",

  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0, 3),
  },
}));

export const ImmutiverseLogo = styled("img")(({ menuOpen }) => ({
  flexShrink: 0,
  aspectRatio: "3 / 1",
  maxHeight: "clamp(24px, 5vw, 40px)",
  transition: "all 0.3s ease-in-out",
  zIndex: 3001,

  "@media (max-width: 900px)": {
    position: menuOpen ? "fixed" : "relative",
    top: menuOpen ? "1.5rem" : "auto",
    left: menuOpen ? "1.5rem" : "auto",
    maxHeight: "34px",
  },
  "@media (max-width: 480px)": {
    maxHeight: "30px",
    maxWidth: "180px",
  },
}));

export const HeaderLeft = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "2rem",
});

export const NavigationLinks = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  "@media (max-width: 900px)": {
    display: "none",
  },
});

export const StyledNavLink = styled("a")(({ active }) => ({
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "0.875rem",
  fontWeight: 400,
  color: "#ffffff" ,
  textDecoration: "none",
  padding: "0.45rem 0.85rem",
  borderRadius: "6px",
  cursor: "default",
  transition: "color 0.18s, background 0.18s",
  whiteSpace: "nowrap",
  background: "transparent",
  border: "none",
  display: "inline-flex",
  alignItems: "center",
  "&:hover": {
    color: "#ffffff",
    background: "rgba(255,255,255,0.06)",
  },
}));

export const NavButton = styled("button")(({ active, open }) => ({
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "0.875rem",
  fontWeight: 400,
  color: "#ffffff",
  textDecoration: "none",
  padding: "0.45rem 0.85rem",
  borderRadius: "6px",
  cursor: "default",
  transition: "color 0.18s, background 0.18s",
  whiteSpace: "nowrap",
  background: "transparent",
  border: "none",
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  "&:hover": {
    color: "#ffffff",
    background: "rgba(255,255,255,0.06)",
  },
}));

export const DropdownContainer = styled("div")({
  position: "relative",
  display: "inline-block",
});

export const DropdownMenu = styled("div")(({ open }) => ({
  position: "absolute",
  top: "calc(100% + 10px)",
  left: 0,
  background: "#161b22",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: "10px",
  padding: "6px",
  minWidth: "200px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
  opacity: open ? 1 : 0,
  pointerEvents: open ? "auto" : "none",
  transform: open ? "translateY(0)" : "translateY(-6px)",
  transition: "opacity 0.18s, transform 0.18s",
  zIndex: 2000,
}));

export const DropdownItem = styled("a")(({ active }) => ({
  display: "block",
  padding: "0.55rem 0.9rem",
  borderRadius: "6px",
  color: active ? "#ffffff" : "rgba(255,255,255,0.72)",
  textDecoration: "none",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "0.85rem",
  transition: "background 0.15s, color 0.15s",
  background: active ? "rgba(255,255,255,0.08)" : "transparent",
  cursor: "default",
  "&:hover": {
    background: "rgba(255,255,255,0.07)",
    color: "#ffffff",
  },
}));

export const DemoButton = styled("a")({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.5rem",
  padding: "0.45rem 1.1rem",
  border: "1px solid rgba(255,255,255,0.6)",
  borderRadius: "6px",
  color: "#ffffff",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "0.875rem",
  fontWeight: 500,
  textDecoration: "none",
  cursor: "pointer", // Change this from "default" to "pointer"
  whiteSpace: "nowrap",
  transition: "background 0.18s, border-color 0.18s",
  "&:hover": {
    background: "rgba(255,255,255,0.08)",
    borderColor: "#ffffff",
  },
});

export const DemoArrow = styled("span")({
  display: "none",
});

export const LogOutBtn = styled("button")({
  background: "none",
  border: "none",
  color: "rgba(255,255,255,0.72)",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "0.875rem",
  fontWeight: 400,
  cursor: "default",
  padding: "0.3rem 0.4rem",
  transition: "color 0.18s",
  "&:hover": {
    color: "#ffffff",
  },
});

export const Caret = styled("span")({
  display: "none",
});

export const Hamburger = styled("div")(({ open }) => ({
  display: "none",
  cursor: "pointer",
  zIndex: 3000,
  "@media (max-width: 900px)": {
    display: "block",
  },
  "& span": {
    display: "block",
    width: "25px",
    height: "2px",
    backgroundColor: "#fff",
    margin: "6px 0",
    borderRadius: "2px",
    transition: "all 0.4s ease-in-out",
  },
  "& span:nth-of-type(1)": {
    transform: open ? "rotate(45deg) translate(5px, 5px)" : "none",
  },
  "& span:nth-of-type(2)": {
    opacity: open ? 0 : 1,
    transform: open ? "translateX(10px)" : "none",
  },
  "& span:nth-of-type(3)": {
    transform: open ? "rotate(-45deg) translate(5px, -5px)" : "none",
  },
}));

export const MobileMenu = styled("div")(({ open }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "#1a1920",
  color: "#fff",
  zIndex: 2500,
  transform: open ? "translateX(0)" : "translateX(100%)",
  transition: "transform 0.4s ease-in-out",
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  padding: "2rem 1.5rem",
}));

export const MobileHeader = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  marginBottom: "1rem",
});

export const CloseIcon = styled("div")({
  fontSize: "40px",
  cursor: "pointer",
  color: "#fff",
  lineHeight: 1,
});

export const MobileLink = styled("div")({
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "1.4rem",
  fontWeight: 500,
  textDecoration: "none",
  color: "#fff",
  margin: "0.4rem 0",
  cursor: "pointer",
  textAlign: "center",
  transition: "color 0.3s ease",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem",
  "&:hover": { color: "#ddd" },
});

export const MobileSubLink = styled("a")({
  display: "block",
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "1rem",
  fontWeight: 400,
  color: "rgba(255,255,255,0.65)",
  textDecoration: "none",
  padding: "0.45rem 0",
  textAlign: "center",
  borderBottom: "1px solid rgba(255,255,255,0.05)",
  transition: "color 0.15s",
  cursor: "default",
  "&:hover": { color: "#fff" },
});

export const MobileSection = styled("div")({
  borderBottom: "1px solid rgba(255,255,255,0.08)",
  paddingBottom: "0.5rem",
  marginBottom: "0.25rem",
});

export const BottomButtons = styled("div")({
  textAlign: "center",
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  alignItems: "center",
});

export const BackLink = styled(MobileLink)({
  fontSize: "1.2rem",
  color: "#888",
});

export const MenuContainer = styled("div")(({ level, menuLevel }) => ({
  position: "absolute",
  top: 0,
  left:
    menuLevel === "main"
      ? level === "main"
        ? 0
        : "-100%"
      : menuLevel === level
      ? 0
      : "100%",
  width: "100%",
  height: "100%",
  transition: "left 0.3s ease",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: level === "main" ? "10rem" : "100px",
  gap: "0.5rem",
  color: "#fff",
}));

export const RiskCalculator = styled("span")(({ active }) => ({
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: 500,
  color: "#fff",
  cursor: "pointer",
  borderBottom: active ? "1px solid #fff" : "1px solid transparent",
  paddingBottom: "2px",
  display: "inline-block",
  transition: "border-bottom 0.3s ease",
  "&:hover": { borderBottom: "2px solid #fff" },
}));